import React from 'react'

const SecondIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.862 9.353c1.325.002 2.372.437 3.088 1.171.711.73 1.043 1.7 1.043 2.676v.011a3.473 3.473 0 0 1-1.392 2.718l-4.167 3.556a3.32 3.32 0 0 0-1.083 1.875h6.482a.64.64 0 0 1 0 1.28H12.65a.64.64 0 0 1-.64-.64 4.602 4.602 0 0 1 1.587-3.484l.004-.003 4.185-3.572a2.194 2.194 0 0 0 .927-1.748c-.001-.688-.234-1.319-.68-1.775-.44-.451-1.14-.785-2.18-.785a2.638 2.638 0 0 0-2.356 1.29.64.64 0 1 1-1.1-.654 3.92 3.92 0 0 1 3.465-1.916Z"
        fill="url(#a)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.998 2.734h13.309v13.309a13.344 13.344 0 0 1-13.305 13.305l-.002-.64-.002.64A13.344 13.344 0 0 1 2.693 16.043l.64-.002-.64-.002A13.344 13.344 0 0 1 15.998 2.734ZM3.973 16.041A12.064 12.064 0 0 0 16 28.068 12.064 12.064 0 0 0 28.027 16.04V4.013H16.001A12.064 12.064 0 0 0 3.973 16.041Z"
        fill="url(#b)"
      />
      <defs>
        <radialGradient
          id="a"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-122.379 18.482 6.846) scale(23.0979 71.0722)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="b"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-38.89594 -39.06875 132.90371 -132.31583 35.987 36.32)"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#9C2AA0" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export default SecondIcon